import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'
import AdvanceTable from '../components/Tables/AdvanceTable';
import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from "../config/axiosConfig";
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: '#7367f0'

    })
}

const firstDate = new Date();
const currentDate = new Date();

class Notifications extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstDay: new Date(firstDate.getFullYear(), firstDate.getMonth(), 1),
            StartDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10), //new Date(date.getFullYear(), date.getMonth(), 1);
            EndDate: new Date().toISOString().substring(0, 10),
            SearchTypeId: '',
            NotificationTypeID: '',
            NoOfRecords: '',
            entriesOptions: [
                { value: '0', label: '25' },
                { value: '1', label: '50' },
                { value: '2', label: '100' }
            ],
            notificationOptions: [
                { value: '0', label: 'All' },
                { value: '1', label: 'Suspicious Transactions' },
                // { value: '2', label: 'Vehicle Health & Maintenance' }
            ],
            data: [],
            columns: [
                { "HeaderText": "Notification Type", "MappingColomn": "messageHeader" },
                { "HeaderText": "Notification Detail", "MappingColomn": "messageBody" },
                { "HeaderText": "Notification Date/Time", "MappingColomn": "dateTime" }
            ],
            PageSize: 10,
            Option: 1,
            Group: 0,
            Vehicle: 0,
            UserBranchID: localStorage.getItem("selectedBranch")
        }


        this.changeHandler = this.changeHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.NoOfRecordsOnChange = this.NoOfRecordsOnChange.bind(this);
        this.NotificationOnChange = this.NotificationOnChange.bind(this);

        this.optionChange = this.optionChange.bind(this)
        this.groupChange = this.groupChange.bind(this)
        this.vehicleChange = this.vehicleChange.bind(this)
    }

    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
    }

    async submitHandler(e) {

        e.preventDefault();
        await this.setState(
            {
                SearchTypeId: 1
            }
        );
        let token = localStorage.getItem('token');

        axiosConfig.post("Portal/GetNotificationDetailForPortal",
            {
                SearchTypeId: 1,
                StartDate: this.state.StartDate,
                EndDate: this.state.EndDate,
                NotificationTypeID: this.state.NotificationTypeID,
                NoOfRecords: 0,
                UserBranchID: this.state.UserBranchID

            }
        )
            .then(Response => {
                this.setState({
                    data: Response.data.notificationDetail
                });
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
        /*End*/

    }

    async NoOfRecordsOnChange(p) {
        await this.setState({
            NoOfRecords: p.value
        });
    }
    async NotificationOnChange(selectedOption) {
        await this.setState({
            NotificationTypeID: selectedOption.value
        });
    }

    async optionChange(selectedOption) {
        console.log(this.state.Option)
        if (this.state.Option != selectedOption && selectedOption == 1) {
            await this.setState({ Option: parseInt(selectedOption), Group: 0, Vehicle: 0 })
        }
        else
            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
    }

    async vehicleChange(selectedVehicle) {
        await this.setState({ Vehicle: selectedVehicle, Group: 0 })
    }

    async groupChange(selectedGroup) {
        await this.setState({ Group: selectedGroup, Vehicle: 0 })

    }


    render() {

        const { SearchTypeId, StartDate, EndDate, NotificationTypeID, NoOfRecords } = this.state;

        return (
            <>
                {/* <CustomHeader/> */}
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Notifications</h4>
                                </div>


                                <div className="card-content">
                                    <div className="card-body"></div>
                                    {/* <div>
                                        <Row>
                                            <GroupVRNSelect
                                                showVehiclesInDropDown='yes'
                                                onOptionChange={this.optionChange}
                                                onGroupChange={this.groupChange}
                                                onVehicleChange={this.vehicleChange}
                                            />
                                        </Row>
                                    </div><br /> */}

                                    <div className="form-body">
                                        <div className="row">
                                            <div className="col-md-6 col-12">
                                                <div className="form-label-group">
                                                    <input type="date" id="StartDate" name="StartDate" value={this.state.StartDate} onChange={this.changeHandler} className="form-control" />
                                                    <label htmlFor="country-floating">Choose Start Time</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-label-group">
                                                    <input type="date" id="EndDate" name="EndDate" value={this.state.EndDate} onChange={this.changeHandler} className="form-control" />
                                                    <label htmlFor="country-floating">Choose End Time</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-12" id="text">
                                                <div className="form-label-group">
                                                    <Select
                                                        options={this.state.notificationOptions}
                                                        styles={customStyles}
                                                        placeholder={'Notification Type'}
                                                        onChange={this.NotificationOnChange}
                                                        defaultValue={{ label: "All", value: "0" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={this.submitHandler}>Generate Report</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-12">
                                        <AdvanceTable data={this.state.data} columns={this.state.columns} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </>

        );
    }
}

export default Notifications;









